import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { TempDocumentDetailResponse } from "apis/data-contracts";

export interface TempDocumentDetailResponseWithAny
  extends TempDocumentDetailResponse {
  documentData: Record<string, any>;
}

/* 임시 저장 문서 상세 조회 */
export const useTempDocumentDetailQuery = (documentUuid?: string) => {
  return useQuery({
    queryKey: api.document.getTempDocumentDetailKey(documentUuid || ""),
    queryFn: () => api.document.getTempDocumentDetail(documentUuid || ""),
    select: (data) => data.data.result as TempDocumentDetailResponseWithAny,
    enabled: !!documentUuid,
    staleTime: 100,
  });
};
